import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSort } from '@btime/react-contexts'
import React from 'react'

import { importsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useImportsState = () => React.useContext(Context) || {}
export const useImports = () => useImportsState()?.imports || []

const QUERY = gql`
  query Imports($page: Int, $sort: ImportSort, $filter: ImportFilter) {
    imports(page: $page, sort: $sort, filter: $filter) {
      id
      entity
      status
      percentage
      insertedAt
      createdBy {
        id
        name
      }
      outputDocument {
        id
        src
      }
    }
  }
`

const ImportsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const entity = useModalData()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      sort: { field: field || 'INSERTED_AT', type: type || 'DESC' },
      filter: { ...filter, entities: entity }
    },
    flexiblePollInterval: 10000,
    client: importsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default ImportsLoader
